import { EnvironmentTypes } from '../enums';
import { parseQuery } from './parse-query';
import { env } from '../environment';

export const getTokenFromReturnPath = (returnPath: string): string | null => {
  if (!returnPath) return null;
  const search = returnPath.includes('?') ? returnPath.slice(returnPath.indexOf('?')) : '';
  return new URLSearchParams(search).get('token');
};

/**
 * The operator URL a relaunch goes back to. Not the current page URL, which carries a one-time
 * launch token that is already spent.
 */
export const getRelaunchUrl = (): string => {
  const { returnPath } = parseQuery(window.location.search);
  const decodedPath = decodeURIComponent(returnPath);
  let redirectUrl = `${env.origin}${decodedPath}`;

  if (env.type === EnvironmentTypes.Development) {
    const url = new URL(redirectUrl);
    url.searchParams.set('redirectPort', '3200');
    redirectUrl = url.toString();
  }

  return redirectUrl;
};
